import { render, staticRenderFns } from "./mainHead.vue?vue&type=template&id=5ade5793&scoped=true&"
import script from "./mainHead.vue?vue&type=script&lang=js&"
export * from "./mainHead.vue?vue&type=script&lang=js&"
import style0 from "./mainHead.vue?vue&type=style&index=0&id=5ade5793&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade5793",
  null
  
)

export default component.exports